import { jsx } from "react/jsx-runtime";
import { validateTidalLicense } from "@workwave-tidal/core/base";
import { useFormFairyBridge } from "../../hooks/useFormFairyBridge.js";
import { FormUITextField } from "../primitives/FormUITextField.js";
function TextField(props) {
  const { autoFocus, placeholder, textfieldProps: textFieldProps, ...bridgeOptions } = props;
  const {
    config: { fullWidth, label, name, testId = "textfield-root" },
    fieldInfo: {
      errorOrHelperText,
      field: { required, visible },
      fieldDisabled,
      fieldHasError,
      onBlur,
      onChange,
      onFocus,
      showErrorAccent,
      value
    }
  } = useFormFairyBridge(bridgeOptions);
  if (!visible) return null;
  const handleOnChange = (event) => {
    onChange(event.currentTarget.value);
  };
  return /* @__PURE__ */ jsx(
    FormUITextField,
    {
      autoFocus,
      fullWidth,
      label,
      placeholder,
      ...textFieldProps,
      testId,
      "data-tidal": "TextField",
      disabled: fieldDisabled,
      error: showErrorAccent && fieldHasError,
      helperText: errorOrHelperText,
      name,
      onBlur,
      onChange: handleOnChange,
      onFocus,
      required,
      value
    }
  );
}
validateTidalLicense();
export {
  TextField
};
//# sourceMappingURL=TextField.js.map
